/**
 * Product siblings: switch product (e.g. color) without full page reload.
 * Updates breadcrumbs, product images, form, title, price, and product-information blocks.
 * Handles add-to-cart after a sibling switch using the Cart API (cart/add.js).
 */
(function () {
  function getProductSection() {
    var productDetail = document.querySelector('.thb-product-detail');
    return productDetail ? productDetail.closest('.shopify-section') : null;
  }

  function getBreadcrumbsSection() {
    var breadcrumbsNav = document.querySelector('nav.breadcrumbs');
    return breadcrumbsNav ? breadcrumbsNav.closest('.shopify-section') : null;
  }

  function getSectionId(sectionEl) {
    return sectionEl && sectionEl.id && sectionEl.id.indexOf('shopify-section-') === 0
      ? sectionEl.id.replace('shopify-section-', '')
      : null;
  }

  function runScriptsInElement(container) {
    if (!container) return;
    var scripts = Array.prototype.slice.call(container.querySelectorAll('script'));
    scripts.forEach(function (script) {
      var newScript = document.createElement('script');
      if (script.src) {
        newScript.src = script.src;
        newScript.async = false;
      } else {
        newScript.textContent = script.textContent;
      }
      if (script.type) newScript.type = script.type;
      script.parentNode.replaceChild(newScript, script);
    });
  }

  function replaceSection(sectionEl, sectionHtml) {
    if (!sectionEl || !sectionHtml || typeof sectionHtml !== 'string') return false;
    var parser = new DOMParser();
    var doc = parser.parseFromString(sectionHtml, 'text/html');
    var newSection = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
    if (!newSection) return false;
    var parent = sectionEl.parentElement;
    if (!parent) return false;
    var next = sectionEl.nextElementSibling;
    var insertEl = document.createElement('div');
    insertEl.innerHTML = newSection.outerHTML;
    var replacement = insertEl.firstElementChild;
    if (!replacement) return false;
    parent.insertBefore(replacement, next);
    sectionEl.remove();
    return replacement;
  }

  function handleSiblingAddToCartSubmit(evt) {
    var form = evt.target && evt.target.tagName === 'FORM' ? evt.target : (evt.target && evt.target.closest && evt.target.closest('form'));
    if (!form || !form.closest || !form.closest('[data-sibling-switched]')) return;
    if (!form.querySelector('[name="id"]')) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    var idInput = form.querySelector('[name="id"]');
    var variantId = (idInput && idInput.value) ? idInput.value.trim() : null;
    if (!variantId) return;

    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = (qtyInput && qtyInput.value) ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    var properties = {};
    var propInputs = form.querySelectorAll('[name^="properties["]');
    for (var p = 0; p < propInputs.length; p++) {
      var input = propInputs[p];
      var name = input.getAttribute('name');
      if (name && name.indexOf('properties[') === 0) {
        var key = name.slice(11, name.length - 1);
        if (key) properties[key] = input.value || '';
      }
    }

    var item = { id: parseInt(variantId, 10), quantity: quantity };
    if (Object.keys(properties).length) item.properties = properties;

    var submitButtons = form.querySelectorAll('.single-add-to-cart-button');
    submitButtons.forEach(function (btn) {
      btn.setAttribute('aria-disabled', true);
      btn.classList.add('loading');
    });

    var errorWrapper = form.closest('[data-sibling-switched]').querySelector('.product-form__error-message-wrapper');
    var errorEl = errorWrapper && errorWrapper.querySelector('.product-form__error-message');
    if (errorWrapper) errorWrapper.setAttribute('hidden', '');
    if (errorEl) errorEl.textContent = '';

    var root = (typeof theme !== 'undefined' && theme.routes && theme.routes.root_url) ? theme.routes.root_url : '/';
    if (root.indexOf('/') !== 0) root = '/' + root;
    var addUrl = root.replace(/\/?$/, '') + '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        submitButtons.forEach(function (btn) {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
        });
        if (data.status && data.message) {
          if (errorWrapper) errorWrapper.removeAttribute('hidden');
          if (errorEl) errorEl.textContent = data.message;
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:item-added', {
          bubbles: true,
          detail: { product: (data.items && data.items[0]) ? data.items[0] : data }
        }));
        if (document.getElementById('Cart-Drawer') && document.getElementById('Cart-Drawer').open) {
          document.getElementById('Cart-Drawer').open();
        }
      })
      .catch(function (err) {
        submitButtons.forEach(function (btn) {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
        });
        if (errorWrapper) errorWrapper.removeAttribute('hidden');
        if (errorEl) errorEl.textContent = (typeof err === 'string') ? err : 'Unable to add to cart.';
      });
  }

  function handleSiblingClick(evt) {
    var link = evt.target.closest('a[href*="/products/"]');
    if (!link || !link.closest('.variations--siblings')) return;
    if (evt.ctrlKey || evt.metaKey || evt.shiftKey) return;

    var href = link.getAttribute('href');
    if (!href || href === '#' || href === '') return;

    evt.preventDefault();

    var sectionEl = getProductSection();
    if (!sectionEl) {
      window.location.href = href;
      return;
    }

    var productSectionId = getSectionId(sectionEl) || 'main-product';
    var breadcrumbsEl = getBreadcrumbsSection();
    var breadcrumbsSectionId = breadcrumbsEl ? getSectionId(breadcrumbsEl) : null;
    var sectionsParam = productSectionId;
    if (breadcrumbsSectionId && breadcrumbsSectionId !== productSectionId) {
      sectionsParam = productSectionId + ',' + breadcrumbsSectionId;
    }

    var productUrl = new URL(href, window.location.origin);

    fetch(productUrl.pathname + '?sections=' + sectionsParam)
      .then(function (res) {
        if (!res.ok) throw new Error('Section fetch failed');
        return res.json();
      })
      .then(function (data) {
        var productHtml = data[productSectionId] || data['main-product'] || (Object.keys(data).length ? data[Object.keys(data)[0]] : null);
        if (!productHtml || typeof productHtml !== 'string') {
          throw new Error('No section HTML');
        }

        if (breadcrumbsSectionId && data[breadcrumbsSectionId]) {
          var breadcrumbsHtml = data[breadcrumbsSectionId];
          if (breadcrumbsHtml && typeof breadcrumbsHtml === 'string') {
            replaceSection(breadcrumbsEl, breadcrumbsHtml);
          }
        }

        var parent = sectionEl.parentElement;
        if (!parent) return;

        var next = sectionEl.nextElementSibling;
        var parser = new DOMParser();
        var doc = parser.parseFromString(productHtml, 'text/html');
        var newSection = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
        if (!newSection) throw new Error('No section element');

        var insertEl = document.createElement('div');
        insertEl.innerHTML = newSection.outerHTML;
        var replacement = insertEl.firstElementChild;
        if (!replacement) throw new Error('No section element');

        var fetchedSectionId = replacement.id ? replacement.id.replace('shopify-section-', '') : null;
        replacement.id = sectionEl.id;
        if (fetchedSectionId && fetchedSectionId !== productSectionId) {
          var attrNodes = replacement.querySelectorAll('[id], [data-section], [for], [form]');
          for (var a = 0; a < attrNodes.length; a++) {
            var node = attrNodes[a];
            var id = node.getAttribute('id');
            if (id && id.indexOf(fetchedSectionId) !== -1) node.id = id.split(fetchedSectionId).join(productSectionId);
            var ds = node.getAttribute('data-section');
            if (ds && ds === fetchedSectionId) node.setAttribute('data-section', productSectionId);
            var forAttr = node.getAttribute('for');
            if (forAttr && forAttr.indexOf(fetchedSectionId) !== -1) node.setAttribute('for', forAttr.split(fetchedSectionId).join(productSectionId));
            var formAttr = node.getAttribute('form');
            if (formAttr && formAttr.indexOf(fetchedSectionId) !== -1) node.setAttribute('form', formAttr.split(fetchedSectionId).join(productSectionId));
          }
        }

        replacement.setAttribute('data-sibling-switched', 'true');

        sectionEl.remove();
        parent.insertBefore(replacement, next);

        runScriptsInElement(replacement);

        history.replaceState({}, '', productUrl.pathname + productUrl.search);

        var newTitleEl = replacement.querySelector('.product-title, .product-information h1, h1.product__title');
        if (newTitleEl && document.title) {
          var shopPart = document.title.indexOf(' – ') !== -1 ? document.title.split(' – ').pop() : '';
          document.title = newTitleEl.textContent.trim() + (shopPart ? ' – ' + shopPart : '');
        }
      })
      .catch(function () {
        window.location.href = href;
      });
  }

  document.addEventListener('click', handleSiblingClick, true);
  document.addEventListener('submit', handleSiblingAddToCartSubmit, true);
})();
